package com.karawek.core.ui.designcatalog.sections

import androidx.compose.foundation.layout.*
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.karawek.core.ui.components.CoreCard
import com.karawek.core.ui.theme.CoreSpacing
import com.karawek.core.ui.theme.CoreTypography

@Composable
fun CatalogStructure() {
    Column(verticalArrangement = Arrangement.spacedBy(CoreSpacing.lg)) {

        Text("Cards & Surfaces", style = CoreTypography.title)

        CoreCard(
            modifier = Modifier.fillMaxWidth(),
        ) {
            Text(
                text = "This is a CoreCard.\nUsed for grouped content.",
                style = CoreTypography.body,
            )
        }

        CoreCard(
            modifier = Modifier.fillMaxWidth(),
        ) {
            Column(verticalArrangement = Arrangement.spacedBy(CoreSpacing.sm)) {
                Text("Card title", style = CoreTypography.bodySecondary)
                Text(
                    "Cards can contain arbitrary layouts.",
                    style = CoreTypography.body,
                )
            }
        }
    }
}
